export const REPORT_FEED_CLIPPING_COUNT = [10, 50, 200, 500] as const;
export const REPORT_FEED_CLIPPING_SORT = ["reach", "echo", "miv", "publication_date"] as const;
